import Vue from 'vue';

export class Login {
    /**
     *
     * @param idLogin
     * @return {Promise}
     */
    static byPK(idLogin) {
        return new Promise((resolve, reject) => {
            Vue.http.get('login/' + idLogin )
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @return {Promise}
     */
    static acessosAtivos(idLogin) {
        return new Promise((resolve, reject) => {
            Vue.http.get('logins/' + idLogin + '/acessos-ativos')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @return {Promise}
     */
    static reboot(idLogin) {
        return new Promise((resolve, reject) => {
            Vue.http.post('logins/' + idLogin + '/reboot')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @return {Promise}
     */
    static remove(idLogin) {
        return new Promise((resolve, reject) => {
            Vue.http.delete('login/' + idLogin )
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @param json
     * @return {Promise}
     */
    static updatePassword(idLogin, json) {
        return new Promise((resolve, reject) => {
            Vue.http.put('logins/' + idLogin + '/update-password', json)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @param id
     * @return {Promise}
     */
    static removeAcessosAtivos(idLogin, id) {
        return new Promise((resolve, reject) => {
            Vue.http.delete('logins/' + idLogin + '/acessos-ativos/' + id)
                .then((res) => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @param idLogin
     * @param id
     * @return {Promise}
     */
    static testarAcessosAtivos(idLogin, id) {
        return new Promise((resolve, reject) => {
            Vue.http.post('logins/' + idLogin + '/acessos-ativos/' + id)
                .then((res) => resolve())
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static check() {
        return new Promise((resolve, reject) => {
            Vue.http.get('check')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static logout() {
        return new Promise((resolve, reject) => {
            Vue.http.post('logout')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static me() {
        return new Promise((resolve, reject) => {
            Vue.http.get('api/v1/me')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }
}
